import { useHandleBack } from "helpers/functions/useHandleBack";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchBrandById } from "slices/brand/thunk";

const BrandDetails = () => {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch<any>();

  const handleBack = useHandleBack("/brand");

  useEffect(() => {
    const fetchBrandDetails = async () => {
      if (state?.brandData) {
        // If data is passed via state, use it
        setData(state.brandData);
      } else if (id) {
        // Otherwise fetch from API
        setLoading(true);
        try {
          const result = await dispatch(fetchBrandById(id)).unwrap();
          setData(result);
        } catch (error) {
          console.error("Failed to fetch brand details", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchBrandDetails();
  }, [id, state, dispatch]);

  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              {/* Header */}
              <Card.Header>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
                  {/* Left side: Back arrow + Title */}
                  <div className="d-flex align-items-center gap-3">
                    <span
                      onClick={handleBack}
                      style={{ color: "#6c757d", textDecoration: "none" }}
                    >
                      <i
                        className="bi bi-arrow-left"
                        style={{ fontSize: "1.2rem", cursor: "pointer" }}
                        aria-label="Back"
                      />
                    </span>
                    <h5 className="card-title mb-0">View Brand</h5>
                  </div>

                  {/* Right side: Breadcrumb */}
                  <div
                    className="text-muted"
                    style={{ fontSize: "0.9rem", cursor: "pointer" }}
                  >
                    <span
                      className="text-muted"
                      style={{ fontSize: "0.9rem", cursor: "pointer" }}
                      onClick={handleBack}
                    >
                      Brand
                    </span>{" "}
                    &gt;{" "}
                    <span
                      className="text-muted"
                      style={{ fontSize: "0.9rem", cursor: "pointer" }}
                    >
                      View Brand
                    </span>
                  </div>
                </div>
              </Card.Header>

              {/* Body */}
              <Card.Body>
                {loading ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" role="status" variant="primary">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : !data && !loading ? (
                  <div className="text-center py-4">
                    <h4>No brand found</h4>
                  </div>
                ) : (
                  <>
                    {/* Brand Details */}
                    <h6 className="mb-3">Brand Details</h6>
                    <Row className="bg-light p-3 rounded mb-4">
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Brand Name : </strong> {data?.brand_name || "-"}
                      </Col>
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Remark : </strong> {data?.remark || "-"}
                      </Col>
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Status : </strong>{" "}
                        <span
                          className={`badge ${data?.status || data?.is_active
                              ? "bg-success"
                              : "bg-danger"
                            }`}
                        >
                          {data?.status || data?.is_active ? "Active" : "Inactive"}
                        </span>
                      </Col>
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Created By : </strong>{" "}
                        {data?.created_by_name || "N/A"}
                      </Col>
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Created Date : </strong>{" "}
                        {formatDate(data?.created_at)}
                      </Col>
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Updated By : </strong>{" "}
                        {data?.updated_by_name || "N/A"}
                      </Col>
                      <Col md={6} xs={12} className="mb-3">
                        <strong>Updated Date : </strong>{" "}
                        {formatDate(data?.updated_at)}
                      </Col>
                    </Row>

                    {/* Back button */}
                    <div className="d-flex justify-content-center">
                      <Button
                        onClick={handleBack}
                        className="btn btn-secondary"
                      >
                        Back
                      </Button>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BrandDetails;

